import Image from "lib/components/atomic/Image";
import React, { useRef } from "react";
import EsewaLogo from "../../../../public/img/esewa.png";
import { useRouter } from "next/router";
import { ArrowSquareOut } from "@phosphor-icons/react";
import { createClassroomSlug } from "utils/slugify";

export interface EsewaPaymentProps {
  fee: string;
  classroomId: string;
  classroomName: string;
  registrantId: string;
}

function EsewaPayment({
  fee,
  classroomId,
  classroomName,
  registrantId,
}: EsewaPaymentProps) {
  let hostname = "https://clamphook.com";
  if (typeof window !== "undefined") {
    hostname =
      window.location.href.split("//")[0] + "//" + window.location.host;
  }
  const router = useRouter();
  const submitRef = useRef<HTMLInputElement | null>(null);
  const disabled =
    !!router.query.onboard && router.query.onboard === "esewasuccess";

  return (
    <div className="relative rounded-2xl border-2 border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:border-[#60bb46] dark:hover:border-[#60bb46] transition-colors overflow-hidden">
      <button
        type="button"
        onClick={() => submitRef.current?.click()}
        disabled={disabled}
        className="w-full flex items-center gap-3 p-4 text-left disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <div className="h-11 w-11 rounded-xl bg-[#60bb46]/10 flex items-center justify-center shrink-0">
          <Image
            cdn={false}
            src={EsewaLogo}
            alt="eSewa"
            className="h-9 w-9 object-contain"
          />
        </div>
        <div className="flex-1 min-w-0">
          <p className="flex items-center gap-1 text-sm font-bold text-gray-900 dark:text-gray-100">
            Pay with eSewa
            <ArrowSquareOut size={13} className="text-gray-400 dark:text-gray-500 shrink-0" />
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Redirects to esewa.com.np · Rs. {fee}
          </p>
        </div>
      </button>
      <form action="https://esewa.com.np/epay/main" method="POST">
        <input value={fee} name="tAmt" type="hidden" />
        <input value={fee} name="amt" type="hidden" />
        <input value="0" name="txAmt" type="hidden" />
        <input value="0" name="psc" type="hidden" />
        <input value="0" name="pdc" type="hidden" />
        <input value="NP-ES-CLAMPHOOK" name="scd" type="hidden" />
        <input
          value={"classroom@" + classroomId + "@" + registrantId}
          name="pid"
          type="hidden"
        />
        <input
          value={
            hostname +
            "/classrooms/" +
            createClassroomSlug(classroomName, classroomId) +
            "?onboard=%22esewasuccess%22"
          }
          type="hidden"
          name="su"
        />
        <input
          value={
            hostname +
            "/classrooms/" +
            createClassroomSlug(classroomName, classroomId) +
            "?onboard=%22esewafailure%22"
          }
          type="hidden"
          name="fu"
        />
        <input
          value="Submit"
          type="submit"
          ref={submitRef}
          className="hidden"
        />
      </form>
    </div>
  );
}
export default EsewaPayment;
